import { FC, useContext } from 'react';
import { DataEntryRow } from '../SchedulePickWizard/styles';
import { InfoLabel, selectBaseStyling } from '../WizardComponents/wizardStyles';
import { DropdownRemoveContainer, smallInputSize } from './styles';
import {
  WizardDropdown,
  WizardDropdownOption,
} from 'common/components/WizardControls/WizardDropdown';
import { Contractor } from 'common/models';
import { CrewAssignmentContext } from './CrewAssignmentWizard';
import { useFormContext } from 'react-hook-form';

export type SelectedHauler = {
  /** String auto-generated by `useForm`'s `useFieldArray` hook */
  id: string;
  hauler: WizardDropdownOption<Contractor> | null;
};

export const AssignHaulersForm: FC<{
  itemIndex: number;
  removeBtn: () => JSX.Element;
}> = ({ itemIndex, removeBtn }) => {
  const { contractorOptions, isLoading } = useContext(CrewAssignmentContext);
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <DataEntryRow>
      <InfoLabel>Hauler {itemIndex + 1}</InfoLabel>
      <DropdownRemoveContainer>
        <WizardDropdown<Contractor>
          name={`haulers[${itemIndex}].hauler`}
          options={contractorOptions}
          formControl={control}
          styles={selectBaseStyling}
          isLoading={isLoading}
          maxWidth={smallInputSize}
          nestedPathError={
            // react-hook typing does not account for nested errors
            (
              errors.haulers as unknown as Record<
                string,
                Record<string, string>
              >[]
            )?.[itemIndex]?.hauler?.message
          }
        />
        {removeBtn()}
      </DropdownRemoveContainer>
    </DataEntryRow>
  );
};
